module.exports = __webpack_public_path__ + "img/J11333.10584210.png";